"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCompaniesWithNoSaas = exports.useDownloadAllServiceStats = exports.useDownloadReviews = exports.mapBy = void 0;
var CSV = __importStar(require("csv-stringify/browser/esm/sync"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var save_file_1 = __importDefault(require("save-file"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var firestore_1 = require("utils/firebase/firestore");
var utils_1 = require("utils/selectors/utils");
var selectors_1 = require("./selectors");
var mapBy = function (arr, getKeyOverride, getVal) {
    var getKey = getKeyOverride !== null && getKeyOverride !== void 0 ? getKeyOverride : (function (obj) { return obj.id; });
    var obj = {};
    arr.forEach(function (item) {
        obj[getKey(item)] = getVal ? getVal(item) : item;
    });
    return obj;
};
exports.mapBy = mapBy;
var useDownloadReviews = function () {
    var _a = __read((0, react_1.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var headers = ['id', 'companyId', 'generalReviewCons', 'generalReviewPros', 'rating', 'reviewedCategories',
        'reviewedFeatures', 'serviceId', 'usedFeatures', 'usedIt', 'userId', 'usageLevel', 'hasAccess', 'accessType',
        'formSubmitted', 'rejectRating', 'deferReview', '_reviewDone'];
    var CUSTOM_FIELD_MAPPER = {
        _reviewDone: fieldProcessors_1.reviewCountCondition,
    };
    return [
        function () { return __awaiter(void 0, void 0, void 0, function () {
            var reviews, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        return [4 /*yield*/, (0, firestore_1.getData)('reviews')];
                    case 1:
                        reviews = (_a.sent()).map((0, fieldProcessors_1.makeCsvRowGenerator)(headers, CUSTOM_FIELD_MAPPER));
                        data = CSV.stringify(__spreadArray([headers], __read(reviews), false));
                        return [4 /*yield*/, (0, save_file_1.default)(data, 'reviews.csv')];
                    case 2:
                        _a.sent();
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); },
        isLoading,
    ];
};
exports.useDownloadReviews = useDownloadReviews;
var useDownloadAllServiceStats = function () {
    var _a = __read((0, react_1.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var headers = ['id', 'serviceId', 'serviceName', 'companyId',
        'companyName', 'createdAt', 'spendLast12Months', 'spend13to24Months', 'spend25to36Months', 'spendBeforeMonth36', 'currency'];
    return [
        function () { return __awaiter(void 0, void 0, void 0, function () {
            function transformDate(createdDate) {
                if (createdDate && createdDate.toDate) {
                    return createdDate.toDate().toISOString();
                }
                return '';
            }
            var allCompanies, allServices, serviceStats, companiesMap, servicesMap, fieldMappers, allServiceStats, allSpend, fileData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        return [4 /*yield*/, (0, firestore_1.getData)('companies')];
                    case 1:
                        allCompanies = _a.sent();
                        return [4 /*yield*/, (0, firestore_1.getData)('services')];
                    case 2:
                        allServices = _a.sent();
                        return [4 /*yield*/, (0, firestore_1.getData)('service_stats')];
                    case 3:
                        serviceStats = _a.sent();
                        companiesMap = (0, exports.mapBy)(allCompanies, function (c) { return c.id; });
                        servicesMap = (0, exports.mapBy)(allServices, function (s) { return s.id; });
                        fieldMappers = {
                            spendLast12Months: function (sS) { return "".concat(sS.calculatedAnnualSpend); },
                            serviceName: function (sS) { var _a; return (_a = servicesMap[sS.serviceId]) === null || _a === void 0 ? void 0 : _a.name; },
                            companyName: function (sS) { var _a; return (_a = companiesMap[sS.companyId]) === null || _a === void 0 ? void 0 : _a.name; },
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            createdAt: function (sS) { var _a; return transformDate((_a = companiesMap[sS.companyId]) === null || _a === void 0 ? void 0 : _a.createdAt); },
                            currency: function (sS) {
                                var currencies = new Set();
                                if (!sS.expenditures) {
                                    return '';
                                }
                                Object.values(sS.expenditures)
                                    .forEach(function (months) { return Object.values(months)
                                    .forEach(function (month) { return month
                                    .forEach(function (exp) { return Object.keys(exp.fxAmount || {}).forEach(function (curr) { return currencies.add(curr); }); }); }); });
                                return __spreadArray([], __read(currencies), false).join();
                            },
                        };
                        allServiceStats = serviceStats
                            .filter(function (sS) { return !sS.isSoftDelete && companiesMap[sS.companyId] && !companiesMap[sS.companyId].isTest; });
                        allServiceStats.sort(function (a, b) { var _a; return (_a = fieldMappers.companyName(a)) === null || _a === void 0 ? void 0 : _a.localeCompare(fieldMappers.companyName(b)); });
                        allSpend = allServiceStats.map((0, fieldProcessors_1.makeCsvRowGenerator)(headers, fieldMappers));
                        fileData = CSV.stringify(__spreadArray([headers], __read(allSpend), false));
                        (0, fieldProcessors_1.saveAsCSV)(fileData, 'All ServiceStats Data.csv');
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); },
        isLoading,
    ];
};
exports.useDownloadAllServiceStats = useDownloadAllServiceStats;
var useGetCompaniesWithNoSaas = function () {
    var nonSaasServices = (0, utils_1.useDebouncedSelector)(selectors_1.selectNonSaasServices);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'services', storeAs: 'nonSaasServices', where: [['isNotSaas', '==', true]] },
        (nonSaasServices === null || nonSaasServices === void 0 ? void 0 : nonSaasServices.length) && (0, lodash_1.chunk)(nonSaasServices, 10).map(function (srvChunk, i) { return ({
            collection: 'service_stats',
            storeAs: "nonSaasServiceStats[".concat(i, "]"),
            where: [['serviceId', 'in', srvChunk.map(function (s) { return s.id; })]],
        }); }),
        { collection: 'companies', storeAs: 'allCompanies' },
    ].flat().filter(Boolean); });
    var companiesWithNonSaas = (0, react_redux_1.useSelector)(selectors_1.selectCompaniesWithNonSaas);
    return (0, react_redux_firebase_1.isLoaded)(nonSaasServices) && (0, react_redux_firebase_1.isEmpty)(nonSaasServices) ? [] : companiesWithNonSaas;
};
exports.useGetCompaniesWithNoSaas = useGetCompaniesWithNoSaas;
